import { Flex, VStack } from '@chakra-ui/react'
import { Container } from '@components/Container'
import { ProductAdvantagesItem, ProductAdvantagesItemProps } from './ProductAdvantagesItem/ProductAdvantagesItem'

export type ProductAdvantagesProps = {
  advantages: ProductAdvantagesItemProps[]
}

export const ProductAdvantages = ({ advantages }: ProductAdvantagesProps) => {
  return (
    <VStack bgColor="gray.50" minHeight="25rem" justifyContent="center" paddingY={{ base: '1rem', md: '2.5rem' }}>
      <Container>
        <Flex width="100%" gridGap={'2.5rem'} flexWrap={'wrap'} justifyContent="center">
          {advantages.map((advantage, index) => (
            <ProductAdvantagesItem key={index} icon={advantage.icon} title={advantage.title} />
          ))}
        </Flex>
      </Container>
    </VStack>
  )
}
